// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__27v6W","col":"Table_col__1M31_","fulfillmentStatus":"Table_fulfillmentStatus__3hXnE","emailCol":"Table_emailCol__2Fmp6"};